export const housingAsssociationContent = [
  {
    heroTitle: "Housing Assocaition Services",
    heroImg: "",
    altText: "",
  },
  {
    introTitle: "Providing The Best Housing Association Maintenance ",
    introText: `Our extensive gas and plumbing maintenance experience within the housing association sector has meant that we are well versed in working with occupied properties in the most professional manner. `,
  },
  {
    contLeftTitle: "Customer Service & Safety",
    contLeftText: `Our vast experience means that landlords and tenants have peace of mind in the standard of gas and plumbing maintenance carried out by AquaHeat`,
    leftImgUrl: `https://res.cloudinary.com/duwmjod0j/image/upload/c_scale,q_80,w_580/v1643108433/AquaHeat/new%20images/Screenshot_2022-01-25_at_10.59.18_ofvuns.webp`,
  },
  {
    contRightTitle: "A Tailored Approach",
    contRightText: `At the heart of what we do is a strong operational service delivery, underpinned by our dedicated customer experience strategy tailored to your needs.`,
    rightImgUrl: `https://res.cloudinary.com/duwmjod0j/image/upload/c_scale,q_80,w_580/v1643108258/AquaHeat/new%20images/Screenshot_2022-01-25_at_10.56.39_d6cnxz.webp`,
  },
  {
    callToActionTitle: "For Maintainance Call On 0113 467 0278",
    callToActionSubTitle: "Servicing Over 8000 homes and businesses",
    callToActionText: `We have a trained team of Gas Safe registered engineers and
              plumbers with a wide range of plumbing experience. Our plumbers
              are available for 24/7 call outs or for regular boiler maintenance
              work or new boiler installations.`,
  },
];
